(function () {
  function validateDlpBuildForm(form) {
    var isValid = true;
    var fields = form.querySelectorAll('input, select, textarea');

    fields.forEach(function (field) {
      if (!field.willValidate) {
        return;
      }

      if (field.tagName === 'SELECT' && field.hasAttribute('required') && field.value === '') {
        field.setCustomValidity('Please select an option.');
      } else {
        field.setCustomValidity('');
      }

      if (!field.checkValidity()) {
        isValid = false;
      }
    });

    return isValid;
  }

  function isShopifyContactForm(form) {
    return !!form.querySelector('input[name="form_type"][value="contact"]');
  }

  function getFormPostUrl(form) {
    var action = form.getAttribute('action');

    if (!action) {
      return window.location.pathname + window.location.search;
    }

    try {
      var targetUrl = new URL(action, window.location.href);
      if (targetUrl.origin !== window.location.origin) {
        return action;
      }
      return targetUrl.pathname + targetUrl.search;
    } catch (error) {
      return window.location.pathname + window.location.search;
    }
  }

  function findCaptchaToken() {
    var selectors = [
      'input[name="h-captcha-response"]',
      'textarea[name="h-captcha-response"]',
      'input[name="g-recaptcha-response"]'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var field = document.querySelector(selectors[i]);
      if (field && field.value) {
        return { name: field.name, value: field.value };
      }
    }

    return null;
  }

  function waitForCaptchaToken(timeout) {
    timeout = timeout || 10000;

    return new Promise(function (resolve) {
      var elapsed = 0;
      var interval = 100;

      function check() {
        if (findCaptchaToken()) {
          resolve();
          return;
        }

        elapsed += interval;
        if (elapsed >= timeout) {
          resolve();
          return;
        }

        setTimeout(check, interval);
      }

      setTimeout(check, 250);
    });
  }

  function buildFormData(form) {
    var formData = new FormData(form);
    var captchaToken = findCaptchaToken();

    if (captchaToken && !formData.get(captchaToken.name)) {
      formData.append(captchaToken.name, captchaToken.value);
    }

    return formData;
  }

  function prepareContactPayload(form, payload) {
    var bodyInput = form.querySelector('input[name="contact[body]"]');
    var nameInput = form.querySelector('input[name="contact[name]"]');

    if (!bodyInput) {
      bodyInput = document.createElement('input');
      bodyInput.type = 'hidden';
      bodyInput.name = 'contact[body]';
      form.appendChild(bodyInput);
    }

    if (!nameInput) {
      nameInput = document.createElement('input');
      nameInput.type = 'hidden';
      nameInput.name = 'contact[name]';
      form.appendChild(nameInput);
    }

    nameInput.value = (payload.firstName + ' ' + payload.lastName).trim();
    bodyInput.value = [
      'Build Application',
      'First Name: ' + payload.firstName,
      'Last Name: ' + payload.lastName,
      'Email: ' + payload.email,
      'Intended Use: ' + payload.intendedUse,
      'Purchase Timeline: ' + payload.purchaseTimeline,
      'Source: ' + payload.formSource,
      'Page: ' + window.location.href
    ].join('\n');
  }

  function trackKlaviyo(form, payload) {
    if (form.dataset.klaviyoEnabled !== 'true') {
      return;
    }

    window._learnq = window._learnq || [];
    window._learnq.push([
      'identify',
      {
        $email: payload.email,
        $first_name: payload.firstName,
        $last_name: payload.lastName,
        dlp_intended_use: payload.intendedUse,
        dlp_purchase_timeline: payload.purchaseTimeline,
        dlp_form_source: payload.formSource
      }
    ]);
    window._learnq.push([
      'track',
      payload.eventName,
      {
        email: payload.email,
        first_name: payload.firstName,
        last_name: payload.lastName,
        intended_use: payload.intendedUse,
        purchase_timeline: payload.purchaseTimeline,
        form_source: payload.formSource,
        page_url: window.location.href,
        submitted_at: new Date().toISOString()
      }
    ]);
  }

  function parseContactResponse(response) {
    var contentType = response.headers.get('content-type') || '';

    if (contentType.indexOf('application/json') !== -1) {
      return response.json().then(function (data) {
        if (data.posted_successfully === true) {
          return data;
        }

        if (response.ok && data.posted_successfully !== false && !(data.errors && Object.keys(data.errors).length > 0)) {
          return data;
        }

        throw new Error('Submission failed');
      });
    }

    if (response.ok || response.redirected) {
      return { posted_successfully: true };
    }

    throw new Error('Submission failed');
  }

  function submitContactForm(form) {
    var formAction = getFormPostUrl(form);
    var requestOptions = {
      method: 'POST',
      credentials: 'same-origin',
      body: buildFormData(form)
    };

    try {
      var targetUrl = new URL(formAction, window.location.href);
      if (targetUrl.origin !== window.location.origin) {
        requestOptions.mode = 'no-cors';
        return fetch(formAction, requestOptions).then(function () {
          return { posted_successfully: true };
        });
      }

      requestOptions.headers = { Accept: 'application/json' };
    } catch (error) {
      requestOptions.headers = { Accept: 'application/json' };
    }

    return fetch(formAction, requestOptions).then(function (response) {
      if (requestOptions.mode === 'no-cors') {
        return { posted_successfully: true };
      }

      return parseContactResponse(response);
    });
  }

  function runWithCaptcha(form, callback) {
    if (isShopifyContactForm(form) && window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
      window.Shopify.captcha.protect(form, callback);
      return;
    }

    callback();
  }

  function wireCaptcha(form) {
    if (!isShopifyContactForm(form)) {
      return;
    }

    if (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
      window.Shopify.captcha.protect(form);
    }
  }

  function setSubmitLoading(submitButton, isLoading) {
    if (!submitButton) {
      return;
    }

    if (isLoading) {
      submitButton.setAttribute('aria-busy', 'true');
      submitButton.disabled = true;
      return;
    }

    submitButton.removeAttribute('aria-busy');
    submitButton.disabled = false;
  }

  function finishSubmit(submitButton) {
    requestAnimationFrame(function () {
      setSubmitLoading(submitButton, false);
    });
  }

  function showSuccess(form, selects, statusMessage) {
    form.reset();
    selects.forEach(function (sel) {
      sel.classList.remove('has-value');
    });

    if (statusMessage) {
      statusMessage.textContent = 'Your submission has been received. If selected for the opportunity to purchase, the Legends team will reach out directly via email.';
      statusMessage.classList.add('is-success');
      statusMessage.classList.remove('is-error');
      statusMessage.hidden = false;
    }
  }

  function showError(statusMessage) {
    if (statusMessage) {
      statusMessage.textContent = 'Something went wrong. Please try again.';
      statusMessage.classList.add('is-error');
      statusMessage.classList.remove('is-success');
      statusMessage.hidden = false;
    }
  }

  function initForm(form) {
    form.setAttribute('data-dlp-form-ready', 'true');

    if (isShopifyContactForm(form)) {
      form.setAttribute('data-shopify-captcha', 'true');
      wireCaptcha(form);
    }

    var selects = form.querySelectorAll('.dlp-build-application__select');
    selects.forEach(function (sel) {
      sel.classList.toggle('has-value', sel.value !== '');
      sel.addEventListener('change', function () {
        this.classList.toggle('has-value', this.value !== '');
        this.setCustomValidity('');
      });
    });

    form.querySelectorAll('input, select, textarea').forEach(function (field) {
      field.addEventListener('input', function () {
        this.setCustomValidity('');
      });
      field.addEventListener('change', function () {
        this.setCustomValidity('');
      });
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      if (!validateDlpBuildForm(this)) {
        this.reportValidity();
        return;
      }

      if (this.dataset.klaviyoSubmitting === 'true') {
        return;
      }

      var statusMessage = this.querySelector('.dlp-build-application__message');
      if (statusMessage) {
        statusMessage.hidden = true;
        statusMessage.textContent = '';
        statusMessage.classList.remove('is-success', 'is-error');
      }

      var submitButton = this.querySelector('.dlp-build-application__submit');
      var emailField = this.querySelector('input[name="contact[email]"]');
      var firstNameField = this.querySelector('input[name="contact[first_name]"]');
      var lastNameField = this.querySelector('input[name="contact[last_name]"]');
      var intendedUseField = this.querySelector('select[name="contact[intended_use]"]');
      var timelineField = this.querySelector('select[name="contact[purchase_timeline]"]');
      var payload = {
        firstName: firstNameField ? firstNameField.value.trim() : '',
        lastName: lastNameField ? lastNameField.value.trim() : '',
        email: emailField ? emailField.value.trim() : '',
        intendedUse: intendedUseField ? intendedUseField.value : '',
        purchaseTimeline: timelineField ? timelineField.value : '',
        eventName: this.dataset.klaviyoEventName || 'Build Application Submitted',
        formSource: this.dataset.klaviyoFormSource || 'DLP Build Application'
      };

      prepareContactPayload(this, payload);

      var self = this;
      var klaviyoEnabled = this.dataset.klaviyoEnabled === 'true';
      this.dataset.klaviyoSubmitting = 'true';

      setSubmitLoading(submitButton, true);

      runWithCaptcha(this, function () {
        waitForCaptchaToken()
          .then(function () {
            trackKlaviyo(self, payload);

            if (klaviyoEnabled) {
              showSuccess(self, selects, statusMessage);
              submitContactForm(self).catch(function () {});
              return;
            }

            return submitContactForm(self).then(function () {
              showSuccess(self, selects, statusMessage);
            });
          })
          .catch(function () {
            if (!klaviyoEnabled) {
              showError(statusMessage);
            }
          })
          .finally(function () {
            delete self.dataset.klaviyoSubmitting;
            finishSubmit(submitButton, statusMessage);
          });
      });
    });
  }

  function init() {
    document.querySelectorAll('.dlp-build-application__form:not([data-dlp-form-ready])').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
